import React from "react";

export default function TNFBIcon() {
  return (
    <>
      <svg
        width="40"
        height="40"
        viewBox="0 0 61 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_754_925)">
          <path
            d="M13.3528 8.77254C13.3528 13.5681 18.7338 18.6241 23.1733 21.9782C25.6643 23.8568 26.9082 24.7991 28.9409 24.7991C30.9736 24.7991 32.2175 23.8568 34.7085 21.9782C39.148 18.621 44.529 13.565 44.529 8.77254C44.529 0.123757 35.9556 -3.10946 28.9409 3.57397C21.9263 -3.10946 13.3528 0.123757 13.3528 8.77254ZM11.0458 60.1011H10.2352C7.29532 60.1011 5.82692 60.101 4.91346 59.1928C4 58.2907 4 56.8275 4 53.9043V50.4572C4 48.8514 4 48.0486 4.41464 47.3294C4.82929 46.6102 5.45593 46.2506 6.70921 45.5252C14.9584 40.7544 26.6713 38.0699 34.4872 42.7043C35.013 43.0163 35.4806 43.3966 35.8901 43.8451C36.3096 44.3009 36.6328 44.8359 36.8407 45.4182C37.0485 46.0005 37.1367 46.6184 37.1001 47.2352C37.0635 47.8521 36.9027 48.4553 36.6274 49.0093C36.3521 49.5633 35.9678 50.0567 35.4973 50.4603C35.1224 50.8142 34.665 51.0698 34.166 51.2043C34.5402 51.1609 34.8987 51.1123 35.2416 51.0586C38.0818 50.6091 40.4667 49.0963 42.6491 47.4565L48.2857 43.2251C49.2919 42.4991 50.5032 42.1082 51.7463 42.1082C52.9894 42.1082 54.2007 42.4991 55.2068 43.2251C56.9932 44.5673 57.5419 46.7776 56.4102 48.5817C55.0915 50.6835 53.2334 53.3711 51.4501 55.0141C49.6668 56.657 47.0044 58.1264 44.8345 59.168C42.4277 60.3242 39.7715 60.9876 37.0686 61.4247C31.5878 62.3051 25.8763 62.1687 20.4517 61.0589C17.3569 60.4255 14.2055 60.1025 11.0458 60.1011Z"
            fill="#7d8895"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_754_925"
            x="0"
            y="0"
            width="61"
            height="70"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_754_925"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_754_925"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </>
  );
}
